import AppRoute from './app-route';

export { AppRoute };
